import { combineReducers } from "redux"
import searchReducers from "./searchReducers"
import createTimelineReducers from "./createTimelineReducers"
import alertReducers from "./alertReducers"
import userReduces from "./userReducers"
import authenticationReducers from "./authtenticationReducers"
import buildconceptReducers from "./buildconceptReducers"
import documentsReducers from "./documentsReducers"
import viewdocumentsReducers from "./viewdocumentsReducers"
import currentSearchReducers from "./currentSearchReducers"
import highlightReducers from "./highlightReducers"
import sourcesReducers from "./sourcesReducers"
import downloadReducers from "./downloadReducers"
import savedSearchReducers from "./savedSearchReducers"
import customTagsReducers from "./customTagsReducers"
import jobReducers from "./jobReducers"
import multiBaseReducer from "./multiBaseReducer"
import bifrostReducers from "./bifrostReducers"
import documentModalReducers from "./documentModalReducers"
import bifrostCaseReducer from "./bifrostCaseReducers"
import notificationReducer from "./notificationReducer"
import themeReducers from "./themeReducers"
import infoReducers from "./infoReducers"
import filterReducers from "./filterReducers"
import bifrostCaseDetailsReducer from "./bifrostCaseDetailsReducers"
import bifrostExtractJobDetailsReducer from "./bifrostExtractJobDetailsReducers"
import viewerReducers from "./viewerReducers"
import usersReducer from "./usersReducer"
import bifrostUploadJobDetailsReducer from "./bifrostUploadJobDetailsReducers"
import bifrostKbMakingDetailsReducer from "./bifrostKbMakingDetailsReducers"
import bifrostPiiDetailsReducer from "./bifrostPiiDetailsReducers"
import dashboardReducer from "./dashboardReducers"
import reviewReducers from "./reviewReducers"
import auditReducer from "./auditReducer"
import headerReducers from "./headerReducers"
import billingReducers from "./billingReducers"
import eventReducers from "./eventReducers"
import taggedDateReducers from "./taggedDateReducers"
import uploadReducers from "./uploadReducers"
import deleteReducers from "./deleteReducers"
import { CLEAR_STORE, LOGOUT_CLEAR_STORE } from "../types"

// Combine all reducers.
const appReducer = combineReducers({
	search: searchReducers,
	alert: alertReducers,
	authtentication: authenticationReducers,
	users: userReduces,
	buildconcept: buildconceptReducers,
	document: documentsReducers,
	timeline: createTimelineReducers,
	viewdocuments: viewdocumentsReducers,
	currentSearchs: currentSearchReducers,
	highlightFilter: highlightReducers,
	sources: sourcesReducers,
	downloads: downloadReducers,
	deleteFile: deleteReducers,
	savedSearch: savedSearchReducers,
	tags: customTagsReducers,
	job: jobReducers,
	multiBase: multiBaseReducer,
	bifrost: bifrostReducers,
	bifrostCase: bifrostCaseReducer,
	bifrostCaseDetails: bifrostCaseDetailsReducer,
	bifrostExtractDetails: bifrostExtractJobDetailsReducer,
	bifrostUploadDetails: bifrostUploadJobDetailsReducer,
	bifrostKbMakingDetails: bifrostKbMakingDetailsReducer,
	bifrostPiiDetails: bifrostPiiDetailsReducer,
	documentModal: documentModalReducers,
	notification: notificationReducer,
	theme: themeReducers,
	info: infoReducers,
	filter: filterReducers,
	viewerData: viewerReducers,
	dashboard: dashboardReducer,
	userManagement: usersReducer,
	review: reviewReducers,
	auditReducer: auditReducer,
	headerReducers: headerReducers,
	billingReducers: billingReducers,
	events: eventReducers,
	taggedDateReducers: taggedDateReducers,
	upload: uploadReducers,
})

const rootReducer = (state, action) => {
	if (action.type === CLEAR_STORE) {
		const { multiBase, users, authtentication } = state // will persist these state while switching the AI base
		return appReducer({ multiBase, users, authtentication }, action)
	}

	if (action.type === LOGOUT_CLEAR_STORE) {
		return appReducer(undefined, action)
	}

	return appReducer(state, action)
}

export default rootReducer
